import * as React from 'react';
import { Text } from '@televet/kibble-ui/build/components/Text';

interface AutomationsFieldLabelProps {
  children: React.ReactNode;
}

export const AutomationsFieldLabel = ({ children }: AutomationsFieldLabelProps): JSX.Element => {
  return (
    <Text size="xl" fontWeight="bold" mb={1} className="Automations__FieldLabel">
      {children}
    </Text>
  );
};
